window.CompatibilityConfig = {
  // Product compatibility rules
  COMPATIBILITY_RULES: {
    // Rules for the primary tracker
    'long-term-gps-tracker': {
      compatible: ['magnetic-mount-for-18-month-long-term-gps-tracker'],
      recommended: {
        handle: 'magnetic-mount-for-18-month-long-term-gps-tracker',
        variantId: '41725568352307'
      }
    }
  }
};

// Inject config if checker is already loaded
if (typeof CompatibilityChecker !== 'undefined') {
  CompatibilityChecker.updateConfig(window.CompatibilityConfig);
}
